export default "__VITE_ASSET__d80fc72e__"